import { createReducer, on } from "@ngrx/store";
import * as PersistentNotificationActions from "./persistent-notification.actions";
import {
  PersistentNotification,
  VIEWED_PERSISTENT_NOTIFICATION_STORAGE_KEY,
} from "./persistent-notification.model";

export const persistentNotificationFeatureKey = "persistentNotification";

export const initialState: PersistentNotification[] = [];

export const persistentNotificationReducer = createReducer(
  initialState,
  on(
    PersistentNotificationActions.loadPersistentNotificationsSuccess,
    (state, action) =>
      action.notifications.map((n) => ({
        ...n,
        viewed: viewed(n.uuid),
      })),
  ),
  on(PersistentNotificationActions.addPersistentNotification, (state, action) =>
    [...state, action.notification].map((n) => ({
      ...n,
      viewed: viewed(n.uuid),
    })),
  ),
  on(
    PersistentNotificationActions.markAllPersistentNotificationViewedSuccess,
    (state) =>
      state.map((n) => ({
        ...n,
        viewed: viewed(n.uuid),
      })),
  ),
);

function viewed(uuid: string) {
  return JSON.parse(
    localStorage.getItem(VIEWED_PERSISTENT_NOTIFICATION_STORAGE_KEY),
  )?.includes(uuid);
}
